export default __webpack_public_path__ + "static/media/poordog6.89ed40d4.jpg";